import * as Constants from '@/common/utils/constants.js';
import * as Messages from '@/common/utils/messages';
import Swagger from '@/common/utils/swagger.js';

export default {
  data() {
    return {
      perpetual: Constants,
      promptInfo: [],
      ALI_CLOUD_DOMAIN_STATIC: Constants.ALI_CLOUD_DOMAIN_STATIC
    };
  },
  methods: {
    // 创建就诊人的入参
    patient_mixin_valueTransmissionInformation() {
      const params = {
        accountId: this.$sn.utils.getAccountId(), // 账号ID
        bindType: this.$sn.utils.getPlatformType(), // 绑定途径
        cardNo: '', // 卡号
        cardType: '1', // 卡类型
        city: '', // 城市
        clinicType: '1', // 就诊类型
        county: '', // 区县
        defaultState: '0', // 是否默认就诊人（1 = 是; 0 = 否）
        guardianIdCardNo: '', // 监护人身份证号
        guardianName: '', // 监护人姓名
        guardianPhone: '', // 监护人手机号
        healthCardId: '', // 健康卡ID
        healthyCardCode: '', // 电子健康卡码值
        hosArea: '', // 医院院区
        hosId: this.$sn.utils.getHospitalId(), // 医院唯一标识
        hospitalId: this.$sn.getConfig('hosHealthCardId'), // 微信医院id*******
        idCardType: '0', // 证件类型
        ignoreGuardian: '', // 是否忽略监护人信息 （0 = 忽略，1 = 不忽略）
        insureCardFlag: '', // 医保类型 Y医保患者 N非医保患者
        insureCardNo: '', // 医保卡号
        insureData: '', // 医保信息*******
        isChildren: '0', // 是否儿童（是否有身份证号）
        isPlatform: '0', // 是否是平台途径（1 = 是; 0 = 否）
        isUse: '1', // 是否启用此就诊人（1 = 是; 0 = 否）
        isVerify: '0', // 0：未核身，1：已核身
        nation: '汉族', // 民族
        nationality: '', // 国籍
        nationalityCode: '', // 国籍编码
        nativePlace: '', // 籍贯
        nativePlaceCode: '', // 籍贯编码
        occupation: '', // 职业
        occupationCode: '', // 职业编码
        ocrContent: '', // 身份证图片*******
        openId: this.$sn.utils.getOpenId(), // 平台唯一标示
        parity: '', // 胎次
        patAllergicHistory: '', // 患者过敏史
        patFamilyHistory: '', // 患者家族史
        patHabit: '', // 患者生活习惯
        patJob: '', // 患者工作
        patKidneyFunction: '', // 患者肾功能
        patLiverFunction: '', // 患者肝功能
        patMarryInfo: '', // 患者婚姻史
        patPastHistory: '', // 患者既往史
        patSurgeryHistory: '', // 患者手术史
        patientAddress: '', // 就诊人地址
        patientBirthday: '', // 生日
        patientId: '', // 就诊人唯一ID
        patientIdCardNo: '', // 证件号
        patientName: '', // 就诊人姓名
        patientPhone: this.$sn.utils.getLoginPhone(), // 就诊人手机号
        patientPresentAddress: '', // 身份证证住址
        patientSex: '', // 性别 (1 = 男; 2 = 女; 0 = 其他)
        patientType: '', // 用户身份类型（省医保，市医保等）
        projectType: this.$sn.utils.getProjectType(), // 类型*******
        province: '', // 省份
        provisionalCardNo: '', // 新生儿临时证件号
        qrCodeText: '', // 二维码文本
        relationType: '', // 与就诊人关系
        street: '', // 街道
        verifyCode: '', // 手机验证码*******
        verifyResult: '', // 人脸核验数据*******
        wechatCode: '', // 腾讯加密的微信唯一标识
        wechatHosId: this.$sn.getConfig('hosHealthCardId'), // 微信注册医院id
        guardianIdCardType: '0', // 监护人证件类型
        verifyPhone: '' // 主账号/院内手机验证码校验
      };
      return params;
    },
    // 修改就诊人入参
    patient_mixin_valueModifyTransmissionInformation(e) {
      const params = {
        bindType: this.$sn.utils.getPlatformType(), // 绑定途径
        city: e.city, // 城市
        county: e.county, // 区县
        defaultState: e.defaultState, // 是否默认就诊人（1 = 是; 0 = 否）
        guardianIdCardNo: e.guardianIdCardNo, // 监护人身份证号
        guardianName: e.guardianName, // 监护人姓名
        guardianPhone: e.guardianPhone, // 监护人手机号
        hosId: this.$sn.utils.getHospitalId(), // 医院唯一标识
        hospitalId: this.$sn.getConfig('hosHealthCardId'), // 微信医院id*******
        idCardNo: e.patientIdCardNo, // 就诊人身份证号
        isChildren: e.isChildren, // 是否儿童（是否有身份证号）
        nation: e.nation, // 民族
        ocrContent: e.ocrContent ? e.ocrContent : '', // 身份证图片*******
        openId: this.$sn.utils.getOpenId(), // 平台唯一标示
        parity: e.parity, // 胎次
        patientAddress: e.patientAddress, // 就诊人详细地址
        patientId: e.patientId, // 就诊人id
        patientPhone: e.patientPhone, // 就诊人手机号
        provisionalCardNo: e.provisionalCardNo, // 新生儿临时证件号
        province: e.province, // 省份
        relationType: e.relationType, // 与就诊人关系
        updateType: e.updateType ? e.updateType : '0', // 0修改就诊人信息，1修改HIS患者信息
        verifyCode: e.verifyCode ? e.verifyCode : '', // 手机验证码*******
        verifyResult: e.verifyResult ? e.verifyResult : '', // 人脸核验数据*******
        projectType: this.$sn.utils.getProjectType() // 类型*******
      };
      return params;
    },
    // 绑卡入参
    patient_mixin_valueCardTransmission(e) {
      const params = {
        bindType: this.$sn.utils.getPlatformType(), // 绑定途径
        cardId: e.cardId, // 卡ID
        cardNo: e.cardNo, // 卡号
        cardType: e.cardType, // 卡类型
        clinicType: e.clinicType, // 就诊类型
        disposable: '', // 门诊住院卡一次性绑定
        extent1: '', // 拓展字段
        extent2: '', // 拓展字段
        extent3: '', // 拓展字段
        extent4: '', // 拓展字段
        hosArea: '', // 院区标示
        hosId: this.$sn.utils.getHospitalId(), // 医院唯一标识
        hospitalId: this.$sn.getConfig('hosHealthCardId'), // 微信医院id*******
        isPlatform: '0', // 是否属于平台
        ocrContent: e.ocrContent ? e.ocrContent : '', // 身份证图片*******
        openId: this.$sn.utils.getOpenId(), // 平台唯一标识
        overdue: '0', // 平卡过期标志
        patCardLimit: '', // 卡功能限制字段
        patCardNoEncrypt: '', // 卡脱敏字段
        patientId: e.patientId, // 就诊人唯一ID
        verifyCode: e.verifyCode ? e.verifyCode : '', // 手机验证码*******
        verifyResult: e.verifyResult ? e.verifyResult : '', // 人脸核验数据*******
        projectType: this.$sn.utils.getProjectType() // 类型*******
      };
      return params;
    },
    // 绑卡温馨提示
    patient_mixin_getPromptInfo(type = 'out', url) {
      const distinction = {
        'bind-card': '/hos/ui/caption/patient/bind-card.js',
        'addition-patient': '/hos/ui/caption/patient/addition-patient.js'
      };
      this.promptInfo = [];
      const params = {
        domain: this.ALI_CLOUD_DOMAIN_STATIC,
        url: distinction[url] + '?time=' + this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyyMMddHHmmss')
      };
      this.$sn.utils.ordinaryRequest(params).then(result => {
        if (result && this.$sn.validate.object(result)) {
          if (result[this.$sn.utils.getHospitalId()] && this.$sn.validate.object(result[this.$sn.utils.getHospitalId()]) && result[this.$sn.utils.getHospitalId()][type].length > 0) {
            this.promptInfo = result[this.$sn.utils.getHospitalId()][type];
          }
          else if (result.ordinary && this.$sn.validate.object(result.ordinary) && result.ordinary[type].length > 0) {
            this.promptInfo = result.ordinary[type];
          }
          if (this.$sn.utils.isOpenFunction(this.perpetual.FUNCTION_ID_DZJKK) && type === 'out' && url === 'bind-card') {
            if (result['health-card'] && result['health-card'].length > 0) {
              if (this.promptInfo.length > 0) this.promptInfo.push(result['health-card'][0]);
              else this.promptInfo = result['health-card'];
            }
          }
        }
        const prompt = {
          info: Messages.PATIENT052,
          style: '',
          sort: '0.91',
          type: '1'
        };
        if (type === 'out' && url === 'bind-card') this.promptInfo.push(prompt);
        this.promptInfo = this.$sn.format.digitalSort(this.promptInfo);
      });
    },

    // 就诊人民族处理数据
    patient_mixin_formatAddressNation(e) {
      if (e && e.nation) {
        if (['未知', '%'].includes(e.nation)) e.nation = '汉族';
        else if (!e.nation.includes('族')) e.nation += '族';
        return e;
      }
    },
    // 获取静态资源 地址、国籍
    patient_mixin_getOssStaticResources(url) {
      return new Promise(resolve => {
        let res = [];
        if (this.$sn.validate.empty(url)) return res;
        const params = {
          domain: this.ALI_CLOUD_DOMAIN_STATIC,
          url: `/hos/ui/js/${url}.js?time= ${this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyyMMddHHmmss')}`
        };
        this.$sn.utils.ordinaryRequest(params).then(result => {
          if (result && result.length > 0) res = result;
          resolve(res);
        });
      });
    },
    // 获取上传身份证的温馨提示和示例图
    patient_mixin_getCaptureCredential(url) {
      return new Promise(resolve => {
        let res = {};
        if (this.$sn.validate.empty(url)) return res;
        const params = {
          domain: this.ALI_CLOUD_DOMAIN_STATIC,
          url: `${url}?time= ${this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyyMMddHHmmss')}`
        };
        this.$sn.utils.ordinaryRequest(params).then(result => {
          if (result && this.$sn.validate.object(result)) res = result;
          resolve(res);
        });
      });
    },
    // fileName: 文件名 card：绑卡 create：添加就诊人/编辑就诊人
    patient_mixin_form(fileName) {
      return new Promise(resolve => {
        const params = {
          domain: this.ALI_CLOUD_DOMAIN_STATIC,
          url: this.$sn.format.caption('/hos/ui/caption/patient/form/pc/{0}.js?time=' + this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyyMMddHHmmss'), [fileName])
        };
        this.$sn.assembly.loading(true);
        this.$sn.utils.ordinaryRequest(params).then(result => {
          this.$sn.assembly.loading(false);
          if (result && this.$sn.validate.array(result) && result.length > 0) {
            resolve(result);
            return false;
          }
          resolve([]);
        });
      });
    },
    // 格式化生日
    patient_mixin_formatBirthday(item) {
      let birthday = '';
      if (item.isChildren === '0' && item.idCardType === '0') {
        birthday = this.$sn.format.birthdayByIdCardSerial(item.patientIdCardNo);
      }
      else {
        const date = item?.patientBirthday || '';
        const regex = /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
        if (date) birthday = regex.test(date) ? date : `${date.substring(0, 4)}-${date.substring(4, 6)}-${date.substring(6, 8)}`;
      }
      return birthday;
    },
    // 拉卡接口
    patient_mixin_getCardInfoByCondition(clinicType = '1', cardType = '1', item = this.$sn.utils.getCurrentPatient()) {
      return new Promise(resolve => {
        const res = {
          code: 0,
          data: [],
          msg: ''
        };
        const params = {
          url: Swagger.getCardInfoByCondition,
          query: {
            patientId: item.patientId,
            hosId: this.$sn.utils.getHospitalId(),
            hosArea: '',
            bindType: this.$sn.utils.getPlatformType(),
            openId: this.$sn.utils.getOpenId(),
            clinicType: clinicType
          },
          header: true
        };
        this.$sn.utils.ordinaryRequest(params).then(result => {
          if (result && result.code === 0 && result.data) {
            if (result.data.length > 0) res.data = result.data;
            else {
              res.code = 400;
              if (clinicType === '1') {
                const isOtherCertificateTypeOnlineFiling = this.$sn.getConfig('isOtherCertificateTypeOnlineFiling');
                const isOtherCertificateTypeOnlineFilingArray = this.$sn.getConfig('isOtherCertificateTypeOnlineFilingArray');
                if (this.$sn.utils.isOpenFunction(this.perpetual.FUNCTION_ID_ZXJD)) {
                  const birth = this.patient_mixin_formatBirthday(item);
                  const createFileMode = (this.$sn.getConfig('createFileMode').indexOf('1') !== -1) ? 1 : 2;
                  if (this.$sn.getConfig('isOnlineAgeLimit')) {
                    if (birth > this.$sn.getConfig('isChildAge')) {
                      if (item.idCardType === '0') res.code = createFileMode;
                      else {
                        if (isOtherCertificateTypeOnlineFiling && isOtherCertificateTypeOnlineFilingArray.includes(item.idCardType)) {
                          res.code = createFileMode;
                          res.msg = '';
                        }
                        else res.msg = this.$sn.format.caption(Messages.PATIENT056, [item.patientName, this.$sn.getConfig('cardTypeName')]);
                      }
                    }
                    else res.msg = this.$sn.format.caption(Messages.PATIENT025, [this.$sn.getConfig('isChildAge')]);
                  }
                  else {
                    // 没有年龄限制
                    if (item.idCardType === '0') res.code = createFileMode;
                    else {
                      if (isOtherCertificateTypeOnlineFiling && isOtherCertificateTypeOnlineFilingArray.includes(item.idCardType)) {
                        res.code = createFileMode;
                        res.msg = '';
                      }
                      else res.msg = this.$sn.format.caption(Messages.PATIENT056, [item.patientName, this.$sn.getConfig('cardTypeName')]);
                    }
                  }
                }
                else res.msg = this.$sn.format.caption(Messages.PATIENT056, [item.patientName, this.$sn.getConfig('cardTypeName')]);
              }
              else res.msg = this.$sn.format.caption(Messages.PATIENT056, [item.patientName, '住院']);
            }
          }
          else {
            res.code = 400;
            res.msg = result && result.msg ? result.msg : Messages.C001;
          }
          resolve(res);
        });
      });
    }
  }
};
